import React from 'react';
import { CountdownBar } from './components/CountdownBar';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { MechanismSection } from './components/MechanismSection';
import { BundleOffer } from './components/BundleOffer';
import { WhatYouGet } from './components/WhatYouGet';
import { WhoIsFor } from './components/WhoIsFor';
import { HowItWorks } from './components/HowItWorks';
import { ProofSection } from './components/ProofSection';
import { PricingSection } from './components/PricingSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTA } from './components/FinalCTA';
import { SalesPopup } from './components/SalesPopup';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  return <div className="min-h-screen bg-white font-inter selection:bg-patriot-red selection:text-white" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <CountdownBar data-id="element-2" />

      <main data-id="element-3">
        <HeroSection data-id="element-4" />

        {/* Main Sales Copy */}
        <ProblemSection data-id="element-5" />
        <MechanismSection data-id="element-6" />

        {/* Offer Details */}
        <BundleOffer data-id="element-7" />
        <WhatYouGet data-id="element-8" />

        {/* Qualification & Process */}
        <WhoIsFor data-id="element-9" />
        <HowItWorks data-id="element-10" />
        <ProofSection data-id="element-11" />

        {/* Conversion */}
        <PricingSection data-id="element-12" />
        <FAQSection data-id="element-13" />
        <FinalCTA data-id="element-14" />
      </main>

      <SalesPopup data-id="element-15" />

      <footer className="bg-navy-dark text-gray-500 text-center py-8 text-sm px-4" data-id="element-16">
        <p className="mb-2" data-id="element-17">
          © {new Date().getFullYear()} Voices of Freedom. All rights reserved.
        </p>
        <div className="flex justify-center gap-4 mb-6" data-id="element-18">
          <a href="#" className="hover:text-white transition-colors" data-id="element-19">
            Terms of Service
          </a>
          <a href="#" className="hover:text-white transition-colors" data-id="element-20">
            Privacy Policy
          </a>
          <a href="#" className="hover:text-white transition-colors" data-id="element-21">
            Contact Us
          </a>
        </div>

        <div className="max-w-2xl mx-auto border-t border-gray-700 pt-6 mt-2" data-id="element-22">
          <p className="text-gray-600 text-xs leading-relaxed" data-id="element-23">
            This site is not a part of the Facebook™ website or Facebook™ Inc.
            Additionally, this site is NOT endorsed by Facebook™ in any way.
            FACEBOOK™ is a trademark of FACEBOOK™, Inc. This is an independent
            tribute publication. All content is created for educational and
            informational purposes only. As stipulated by law, we can not and do
            not make any guarantees about your ability to get results or earn
            any money with our ideas, information, tools, or strategies. We just
            want to help by giving great content, direction, and strategies.
          </p>
        </div>
      </footer>
    </div>;
}